export default __webpack_public_path__ + "static/media/paaths-home-header.76432969.png";